var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GeneralCard',{attrs:{"title":_vm.title,"value":`${_vm.formatValue(_vm.top3Value)}/${_vm.formatValue(_vm.totalValue)}`,"optionValue":_vm.calculateContributionPercentage(_vm.top3Value, _vm.totalValue)}})
}
var staticRenderFns = []

export { render, staticRenderFns }